import { cx } from '@linaria/core';
import { useState, useEffect } from 'react';
import { USER_AREA_BASE_PATH } from '@pm2/api';
import { NotificationCount } from '@pm2/react-utils';
import { useNavigationManager, Link } from '@provider/navigation';
import { useLoaderState, Chevron } from '@utils/react';
import { iconWrapper, labelCls, stateWrapperCls, throbberCls, throbberWrapperCls, chevron, linkCls } from './atom.link.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const InternalLink = props => {
  const [isPending, setPending] = useState(false);
  const href = `${USER_AREA_BASE_PATH}/${props.target}`;
  const navigation = useNavigationManager();
  const showThrobber = useLoaderState(isPending);
  useEffect(() => {
    return navigation.subscribe(() => {
      setPending(false);
    });
  });
  const onClick = async evt => {
    evt.preventDefault();
    evt.stopPropagation();
    try {
      setPending(true);
      await navigation.push(href);
    } catch (err) {
      console.warn("UserArea.InternalLink(): Failed to navigate..", err);
      setPending(false);
    }
  };
  return /*#__PURE__*/jsxs(Link, {
    href: href,
    className: cx(linkCls, props.active && "active"),
    onClick: onClick,
    children: [/*#__PURE__*/jsxs("div", {
      className: iconWrapper,
      children: [props.icon, /*#__PURE__*/jsx(NotificationCount, {
        count: props.count,
        active: !!props.count
      })]
    }), /*#__PURE__*/jsx("span", {
      className: labelCls,
      children: props.label
    }), /*#__PURE__*/jsxs("span", {
      className: stateWrapperCls,
      children: [/*#__PURE__*/jsx("span", {
        className: cx(throbberWrapperCls, !showThrobber.current && "hidden"),
        children: /*#__PURE__*/jsx("span", {
          className: throbberCls
        })
      }), /*#__PURE__*/jsx("span", {
        className: cx(chevron, showThrobber.current && "hidden"),
        children: /*#__PURE__*/jsx(Chevron, {
          size: 8,
          lineWidth: 1.5
        })
      })]
    })]
  });
};

export { InternalLink };
//# sourceMappingURL=atom.link.js.map
